import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=22b6533f&scoped=true&"
import script from "./videotable.js?vue&type=script&lang=js&"
export * from "./videotable.js?vue&type=script&lang=js&"
import style0 from "./VideoTable.vue?vue&type=style&index=0&id=22b6533f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6533f",
  null
  
)

export default component.exports